module.exports = __webpack_public_path__ + "img/mental4.d8228ebd.png";